import {useQuery} from "react-query";
import {getAxios} from "../../axios/generic-api-calls";
import {CountryModel} from "./countryTypes";

export function useFetchCountries(key:string = 'countries') {
    return useQuery<CountryModel[]>(key, () => getAxios(`/country`));
}
